export const LAMBDA_PAYMENT_SUCCESS = 1
export const LAMBDA_PAYMENT_SUCCESS_APPLY_FAIL = -5
export const LAMBDA_PAYMENT_REQUIRES_FURTHER_VALIDATION = 2
export const MESSAGE_TOKEN_TIME_OUT = "TIMEOUT"
export const CURRENCY_REGEX = /^\d+(?:\.\d{2})$/